import React from 'react';

const KesehatanMentalPengembangMuda: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Dunia pengembangan perangkat lunak dan kompetisi teknologi sering kali diidentikkan dengan begadang larut malam di depan monitor, konsumsi minuman berkafein tinggi, dan tekanan batas waktu yang ketat. Bagi pelajar dan mahasiswa, ritme kerja yang tidak seimbang ini dapat memicu kejenuhan kronis (<i>burnout</i>), penurunan motivasi belajar, serta gangguan kesehatan fisik dan mental.
      </p>

      <p className="mb-4">
        Menjadi inovator yang produktif dan berprestasi bukan berarti harus mengorbankan kesejahteraan diri. Menjaga keseimbangan antara ambisi berkarya dan pemulihan energi merupakan kunci utama ketahanan jangka panjang dalam meniti karier di dunia teknologi.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Strategi Menjaga Kebugaran Mental Programmer
      </h2>
      <ol className="list-decimal pl-6 mb-6 space-y-3">
        <li>
          <strong>Terapkan Teknik Pomodoro:</strong> Bekerja fokus selama 25 menit, lalu istirahatkan mata dan pikiran selama 5 menit tanpa menatap layar gadget sama sekali.
        </li>
        <li>
          <strong>Aturan 20-20-20 untuk Kesehatan Mata:</strong> Setiap 20 menit menatap monitor, alihkan pandangan ke objek sejauh 20 kaki (sekitar 6 meter) selama 20 detik untuk meredakan ketegangan otot mata.
        </li>
        <li>
          <strong>Aktivitas Fisik dan Olahraga Ringan:</strong> Melakukan peregangan leher, bahu, dan punggung serta berjalan kaki di luar ruangan membantu melancarkan sirkulasi oksigen ke otak.
        </li>
        <li>
          <strong>Tidur Berkualitas yang Cukup:</strong> Tidur 7–8 jam sehari sangat krusial bagi otak untuk mengkonsolidasikan ingatan logika algoritma baru yang dipelajari sepanjang hari.
        </li>
      </ol>

      <div className="bg-blue-50 border-l-4 border-defaultBlue p-4 mb-4 rounded-r-lg">
        <p className="text-gray-800 text-sm">
          <b>&quot;Kesehatan mental yang prima dan pikiran yang jernih adalah fondasi utama lahirnya baris kode yang bersih dan solusi algoritma yang brilian.&quot;</b>
        </p>
      </div>

      <p className="mb-4">
        Ingatlah bahwa perjalanan belajar teknologi adalah sebuah maraton panjang, bukan lari cepat sesaat. Rawatlah pikiran dan tubuh Anda dengan baik agar Anda dapat terus berinovasi dan memberikan dampak positif bagi dunia.
      </p>
    </div>
  );
};

export default KesehatanMentalPengembangMuda;
